<template>
  <div v-loading="listLoading">
    <div v-show="isPagination" class="search-result">
      <div>
        <span v-if="code" class="result-title"> {{ wd | titleFilter }}</span>
        <span v-if="code">-</span>
        {{ title }}
      </div>
    </div>
    <div v-show="isPagination" class="headerTitle">
      <div class="title">
        标题
      </div><div class="time">
        发布日期
      </div>
    </div>
    <el-main :class="isPagination ? 'el-main':'el-main-all'">
      <div v-if="dataList && dataList.length>0">
        <div v-for="(item, index) in dataList" :key="index" class="news-item" @click="goInfo(item)">
          {{ item.title }}
          <span class="right">{{ item.createDate }}</span>
        </div>
      </div>
      <global-empty
        v-else
        :label="`暂无数据~`"
        link-it="3"
        height="200"
      />
    </el-main>
    <pagination
      v-show="isPagination"
      :total="searchForm.total"
      :page.sync="searchForm.pageNum"
      :limit.sync="searchForm.pageSize"
      @pagination="pageCurriculumList"
      @handleSizeChange="handleSizeChange"
    />
  </div>
</template>
<script>
import { getAppList } from '@/api/search';

// 获取API
export default {
  name: 'NewsTabList',
  props: {
    propsData: {
      type: Object,
      default: Object
    },
    isPagination: {
      type: Boolean,
      default: true
    },
    code: { // 搜索页才传code字段，可作为是否是搜索页判断字段
      type: String,
      default: ''
    },
    wd: {
      type: String,
      default: ''
    },
    searchClick: {
      type: String,
      default: ''
    }
  },
  data: () => {
    return {
      classifyId: '',
      searchForm: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      title: '资讯',
      dataList: [],
      listLoading: true
    };
  },
  watch: {
    $route: {
      handler: function() {
        // this.getInfo();
      },
      immediate: true
    },
    wd: {
      handler: function(val) {
        console.log('资讯与公告：' + val);
        this.wd = val;
      },
      immediate: true
    },
    searchClick: {
      handler: function(val) {
        console.log('点击了资讯与公告：' + val);
        this.getInfo();
      },
      immediate: true
    }
  },
  methods: {
    // 获取列表
    getInfo() {
      this.listLoading = true;
      // 搜索页的资讯列表
      if (this.code) {
        if (!this.isPagination) {
          this.searchForm.pageSize = 4; // 全部类型只查询四条
        }
        const params = {
          code: this.code,
          pageNum: this.searchForm.pageNum,
          pageSize: this.searchForm.pageSize,
          q: this.wd
        };
        getAppList(params).then(res => {
          if (this.code === 'S04') {
            this.title = '资讯';
            this.dataList = res.data.S04.list;
            this.searchForm.total = res.data.S04.total;
            this.listLoading = false;
            this.$parent.resultCountClick(this.searchForm.total);
          } else if (this.code === 'S05') {
            this.title = '活动公告';
            this.dataList = res.data.S05.list;
            this.searchForm.total = res.data.S05.total;
            this.listLoading = false;
            this.$parent.resultCountClick(this.searchForm.total);
          } else if (this.code === 'S13') {
            this.title = '校园动态';
            this.dataList = res.data.S13.list;
            this.searchForm.total = res.data.S13.total;
            this.listLoading = false;
            this.$parent.resultCountClick(this.searchForm.total);
          } else if (this.code === 'S14') {
            this.title = '校园风采';
            this.dataList = res.data.S14.list;
            console.log(this.dataList);
            this.searchForm.total = res.data.S14.total;
            this.listLoading = false;
            this.$parent.resultCountClick(this.searchForm.total);
          }
        });
        return;
      }
    },
    goInfo(item) {
      if (this.code === 'S04') {
        this.$router.push({ name: 'Detail', params: { id: item.id }, query: { source: 'news' }});
      } else if (this.code === 'S05') {
        this.$router.push({ name: 'Detail', params: { id: item.id }, query: { source: 'announcement' }});
      } else if (this.code === 'S13') {
        this.$router.push({ name: 'Detail', params: { id: item.id }, query: { source: 'schoolnews' }});
      }
    },
    // 分页
    pageCurriculumList(obj) {
      this.searchForm.pageNum = obj.page;
      this.getInfo();
    },
    // 分页条数变化
    handleSizeChange(obj) {
      this.searchForm.pageNum = 1;
      this.searchForm.pageSize = obj.limit;
      this.getInfo();
    }
  }
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.el-main{
  padding: 10px 40px 20px 40px;
}
.el-main-all{
  padding: 10px 20px 20px 20px;
}
 .news-item{
    border-bottom: 1px solid transparent;
    background: linear-gradient(white,white) padding-box,
    repeating-linear-gradient(-45deg,#ccc 0, #ccc 0.30em,white 0,white 0.55em);
      //  border-bottom: #ECECEC 1px dashed;
    line-height: 19px;
    padding: 14px 0px;

  }
  .news-item:hover{
    color: #007AFC;
    cursor: pointer;
    border-bottom: 1px solid transparent;
    // text-decoration: underline;
    background: linear-gradient(white,white) padding-box,
    repeating-linear-gradient(-45deg,#ccc 0, #ccc 0.30em,white 0,white 0.55em);
  }
  .search-result{
    display: flex;
    justify-content: space-between;
    padding: 10px 0 0 0;
    margin: 0 16px 0 20px;
    font-weight: bold;
    font-size: 18px;
    .result-title{
    font-weight: bold !important;
    font-size: 18px !important;
  }
  div{
    font-size: 18px;
    color: #787878;
    font-weight: 500;
  }
  span{
    color: #0082F1;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    cursor: pointer;
  }
}
.headerTitle{
  display: flex;
    background: #f4f4f4;
    height: 54px;
    line-height: 54px;
    font-size: 16px;
    padding: 0 40px;
    margin-bottom: 20px;
    margin: 20px 18px 0 18px;
  .title{
    flex: 1;
    color: #333333;
  }
  .time{
   width: 200px;
   text-align: right;
  }
}
</style>
